const Trademark = ({isMobile}) => {
    return <div id="copyright"> 
    {isMobile && <div className="item-divider-long" style={{height: 1, width:'80vw', opacity:1}}></div>}
    © 2026 The Average Collector Pty Ltd. All rights reserved.
    </div>
}

export default Trademark